import React from "react";
import { useNavigate } from "react-router-dom";
function Reminder({ data }) {
  const navigate = useNavigate();
  return (
    <>
      <div className="lead_dashboard_reminder p-1">
        {data?.length > 0
          ? data?.map((item, index) => (
              <div
                key={index}
                className="border border-primary rounded p-2 mb-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate(
                    "/companyinfo/view/" + item.id,
                  );
                }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div>
                      <h6 className="fw-medium mb-1">{item.name}</h6>
                      <p className="text-truncate fs-12 mb-0">
                        <i className="fa-regular fa-clock text-danger text-opacity-50"></i>{" "}
                        {item.meeting_date.slice(0, 10)}
                      </p>
                      <p className="text-muted op-7 fs-10">
                        {item?.notes ? (
                          item?.notes
                        ) : (
                          <span className="text-danger">No Notes Added</span>
                        )}
                      </p>
                    </div>
                  </div>
                  <span className="badge badge-purple d-inline-flex align-items-center">
                    <i className="ti ti-point-filled me-1"></i> Scheduled
                  </span>
                </div>
              </div>
            ))
          : "No Reminder Found"}
      </div>
    </>
  );
}

export default Reminder;
